import * as Backbone from "backbone";
import {CachingCollection} from "./_BaseCollection";

interface TemplateConversionFunctionCollectionOptions {
    sensorType: number
    sensorVersion: number
}

export class TemplateConversionFunctionCollection extends CachingCollection<Backbone.Model> {

    sensorType: number;
    sensorVersion: number;

    constructor(initialModels: Object[] | any[], options: TemplateConversionFunctionCollectionOptions) {
        super(initialModels, options);
        this.sensorType = options.sensorType;
        this.sensorVersion = options.sensorVersion;
    }

    url = () => {
        return window.location.origin + '/api/v1/templates/conversionfunctions/' + this.sensorType + '/' + this.sensorVersion;
    };

    comparator = (model) => {
        return model.get('name');
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/TemplateConversionFunctions.ts